import React, { useState } from 'react';
import {
  Box,
  IconButton,
  makeStyles,
  Popover,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { Type as TypeIcon } from 'react-feather';
import { SvgIcon } from '@material-ui/core';
import useSettings from 'src/hooks/useSettings';
import { useTranslation } from 'react-i18next';

const FONT_SIZES = [
  { label: 'S', value: 12 },
  { label: 'M', value: 14 },
  { label: 'L', value: 16 },
  { label: 'XL', value: 18 },
];

const useStyles = makeStyles((theme) => ({
  popoverPaper: {
    padding: theme.spacing(1.5, 2),
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    minWidth: 140,
    borderRadius: 12,
    boxShadow: '0 8px 32px rgba(0,0,0,0.16)',
  },
  title: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    marginBottom: 4,
  },
  row: {
    display: 'flex',
    gap: 8,
  },
  sizeBtn: {
    flex: 1,
    padding: '6px 0',
    borderRadius: 6,
    border: `1px solid ${theme.palette.divider}`,
    background: 'none',
    cursor: 'pointer',
    fontFamily: 'inherit',
    transition: 'background 0.15s, border-color 0.15s',
    '&:hover': {
      background: theme.palette.action.hover,
    },
  },
  sizeBtnActive: {
    borderColor: theme.palette.primary.main,
    background: `${theme.palette.primary.main}18`,
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
}));

const FontSizeSwitcher = ({ iconColor = 'inherit' }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [anchorPos, setAnchorPos] = useState(null);
  const { settings, saveSettings } = useSettings();
  const { t } = useTranslation();

  const currentSize = settings.fontSize || 14;

  const handleOpen = (e) => {
    const navBottom = document.querySelector('header')?.getBoundingClientRect()?.bottom ?? 56
    const rect = e.currentTarget.getBoundingClientRect()
    setAnchorPos({ top: navBottom, left: rect.right })
    setOpen(true)
  }

  const handleSelect = (value) => {
    saveSettings({ fontSize: value });
    setOpen(false);
  };

  return (
    <>
      <Tooltip title={t('fontSizeSwitcher.tooltip')}>
        <IconButton
          size="small"
          onClick={handleOpen}
          style={{ color: iconColor, padding: 8 }}
        >
          <SvgIcon style={{ fontSize: 18 }}>
            <TypeIcon />
          </SvgIcon>
        </IconButton>
      </Tooltip>

      <Popover
        open={open}
        anchorReference="anchorPosition"
        anchorPosition={anchorPos || { top: 56, left: 0 }}
        onClose={() => setOpen(false)}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        style={{ zIndex: 1400 }}
        PaperProps={{ className: classes.popoverPaper }}
      >
        <Typography className={classes.title}>
          {t('fontSizeSwitcher.label')}
        </Typography>
        <Box className={classes.row}>
          {FONT_SIZES.map(({ label, value }) => (
            <button
              key={value}
              className={`${classes.sizeBtn} ${currentSize === value ? classes.sizeBtnActive : ''}`}
              style={{ fontSize: value - 2 }}
              onClick={() => handleSelect(value)}
            >
              {label}
            </button>
          ))}
        </Box>
      </Popover>
    </>
  );
};

export default FontSizeSwitcher;
